import { memo } from "react";
import { Paperclip } from "lucide-react";

import type { UserTimelineItem, UserAttachment } from "@/hooks/useChat";
import { MessageFrame } from "./MessageFrame";

const AttachmentList = memo(function AttachmentList({
  attachments,
}: {
  attachments: UserAttachment[];
}) {
  if (attachments.length === 0) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {attachments.map((att) => (
        <span
          key={att.path}
          className="inline-flex items-center gap-1 rounded-md bg-zinc-900/[0.07] px-2 py-0.5 text-[12px] text-zinc-600"
        >
          <Paperclip className="h-3 w-3" />
          <span className="max-w-[140px] truncate">{att.filename}</span>
        </span>
      ))}
    </div>
  );
});

export const UserCard = memo(function UserCard({
  item,
}: {
  item: UserTimelineItem;
}) {
  return (
    <MessageFrame side="user">
      <div className="rounded-2xl bg-zinc-100 px-4 py-2.5 text-[14px] text-zinc-900 break-words overflow-hidden">
        <span className="whitespace-pre-wrap leading-relaxed">
          {item.text}
        </span>
        {item.attachments && <AttachmentList attachments={item.attachments} />}
      </div>
    </MessageFrame>
  );
});
